import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";

export type PatientTokenInfo = {
  tokenNo: string | number;
  queueGeneratedAt?: string | Date | null;
};

interface ModalHeaderProps {
  onClose: () => void;
  theme?: "light" | "dark";
}

export function formatTokenTime(value?: string | Date | null): string {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d
    .toLocaleTimeString("en-GB", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .replace(/\b(a\.?m\.?|p\.?m\.?)\b/gi, (m) =>
      m.toLowerCase().startsWith("p") ? "PM" : "AM"
    );
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  onClose,
  theme = "light",
}) => {
  const isDark = theme === "dark";

  return (
    <header
      className={`shrink-0 flex items-center justify-between gap-4 px-4 sm:px-6 py-3.5 border-b ${
        isDark
          ? "border-slate-700 bg-slate-900/80 backdrop-blur-md"
          : "border-slate-200 bg-white/90 backdrop-blur-md"
      }`}
    >
      <div className="flex items-center gap-3 min-w-0">
        <span
          className={`flex h-9 w-9 items-center justify-center rounded-xl ${
            isDark ? "bg-indigo-500/20 text-indigo-300" : "bg-indigo-50 text-indigo-600"
          }`}
        >
          <LocalHospitalOutlinedIcon sx={{ fontSize: 20 }} />
        </span>
        <div className="min-w-0">
          <h2
            id="patient-summary-title"
            className={`text-base sm:text-lg font-bold tracking-tight truncate ${
              isDark ? "text-white" : "text-slate-900"
            }`}
          >
            Patient Summary
          </h2>
          <p className={`text-xs truncate ${isDark ? "text-slate-500" : "text-slate-500"}`}>
            Clinical overview
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={onClose}
        className={`flex h-9 w-9 items-center justify-center rounded-xl transition-colors shrink-0 ${
          isDark
            ? "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
            : "bg-slate-100 text-slate-600 hover:bg-slate-200"
        }`}
        aria-label="Close patient summary"
      >
        <CloseIcon sx={{ fontSize: 20 }} />
      </button>
    </header>
  );
};

export default ModalHeader;
